import { AppInteraction } from '@org-avp/naap-app-sdk';

let secondWindow: Window | null = null;

/**
 * Opens a URL on a secondary screen using the Window Management API.
 * Falls back gracefully if the API is not available or only one screen is detected.
 */
const openWindow = async (url: string) => {
  try {
    console.log('openWindow called with URL:', url);

    if ('getScreenDetails' in window) {
      console.log('Window Management API detected');
      // biome-ignore lint/suspicious/noExplicitAny: Window Management API not yet in TypeScript DOM types
      const screens = await (window as any).getScreenDetails();
      console.log('Screen details retrieved:', screens);
      console.log('Number of screens:', screens.screens.length);

      if (screens.screens.length > 1) {
        const secondScreen = screens.screens[1];
        console.log('Secondary screen details:', {
          width: secondScreen.width,
          height: secondScreen.height,
          left: secondScreen.left,
          top: secondScreen.top,
        });

        const { width, height, left, top } = secondScreen;
        const windowFeatures = `popup=yes,width=${width},height=${height},left=${left},top=${top}`;
        console.log('Opening window with features:', windowFeatures);

        secondWindow = window.open(url, 'secondScreen', windowFeatures);
        console.log('Window opened successfully:', secondWindow);
      } else {
        console.warn('Only one screen detected');
        alert('Only one screen detected.');
      }
    } else {
      console.warn('Window Management API not supported');
      alert('Window Management API not supported.');
    }
  } catch (error) {
    console.error('Error using Window Management API:', error);
  }
};

const updateConfig = (config: string) => {
  try {
    console.log('Config received from app:', config);
    const parsedConfig = JSON.parse(config);
    const { mainUrl, secondUrl } = parsedConfig;

    if (mainUrl) {
      const iframe = document.querySelector('iframe');
      if (iframe) {
        iframe.src = mainUrl;
      }
    }

    if (secondUrl) {
      openWindow(secondUrl);
    }
  } catch (error) {
    console.error('Error parsing config:', error);
  }
};

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const app = await AppInteraction.init();
    app.on('config', (config) => {
      updateConfig(config);
    });
    const config = await app.requestConfig();
    updateConfig(config);
  } catch (error) {
    console.error('Error initializing app interaction:', error);
  }
});

window.onbeforeunload = () => {
  if (secondWindow && !secondWindow.closed) {
    secondWindow.close();
  }
};
